export default __webpack_public_path__ + "static/media/Porcentaje.a07c53ac.svg";